import { render, staticRenderFns } from "./BuildingShowDetailsTab.vue?vue&type=template&id=28f9ce78"
import script from "./BuildingShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports